import { connect } from 'react-redux';
import Component from './Component';

import componentDidMount from './Handlers/componentDidMount';
import onClickCancel from './Handlers/onClickCancel';
import onClickSubmit from './Handlers/onClickSubmit';
import onClickDelete from './Handlers/onClickDelete';

const mapStateToProps = (state, ownProps) => ({
  submitting: state.modals.Supplier.submitting,
  supplier: state.modals.Supplier.supplier || ownProps.supplier,
});

const actionCreators = {
  componentDidMount,
  onClickCancel,
  onClickSubmit,
  onClickDelete,
};

export default connect(mapStateToProps, actionCreators)(Component);
